$(document).ready(function() {
  // PRODUCT PAGE ------> JS -- START
  if(document.body.classList.contains("template-product")){

    // section: product-tab-with-modal.liquid
    productTabWithModal();
  
    // section: product-accordions.liquid
    $(document).on("click","[data-pro-accordion-btn]",function(e) {
        e.preventDefault();
        // $(this).parents(".product-accordions-item").siblings().removeClass("active");
        // $(this).parents(".product-accordions-item").siblings().removeClass("active").find(".product-accordions-content").slideUp();
        $(this).parents(".product-accordions-item").toggleClass("active");
        $(this).parents(".product-accordions-item").find(".product-accordions-content").slideToggle();
    });
    
  }
  // PRODUCT PAGE ------> JS -- END
  
  // product video section btn click
  let pdpVideoBtns = document.querySelectorAll(".product-video-main .product-video-btn") || null;
  pdpVideoBtns.forEach(pdpVideoBtn => {
    pdpVideoBtn.addEventListener("click",function(e) {
      e.preventDefault();
      if(this.closest(".product-video-wrap")){
        this.closest(".product-video-wrap").classList.add("clicked");
        let allVidWraps = document.querySelectorAll(".product-video-wrap");
        if(allVidWraps.length > 1){
          allVidWraps.forEach(ele => {
           // if(ele.querySelector("video")) ele.querySelector("video").removeAttribute("controls");
           if(ele.querySelector("video")) ele.querySelector("video").pause();
          });
        }
        // .querySelector("video").play();
        if(this.closest(".product-video-wrap").querySelector("video")) this.closest(".product-video-wrap").querySelector("video").setAttribute("controls","controls");
        if(this.closest(".product-video-wrap").querySelector("video")) this.closest(".product-video-wrap").querySelector("video").play();
      }
    });
  });
  
  // section : new-featured-collection.liquid
  let newFeaturedColl = document.querySelector("[data-systems-slider]") || null;
  if(newFeaturedColl){
    newFeaturedCollSlider();
  }
  
  // section : Instagram-section.liquid
  let insta = document.querySelector("[data-social-slider]") || null;
  if(insta){
    instaSection();
  }
  
  // section : photo-tiles.liquid
  let photoTiles = document.querySelector("[data-photo-tiles-slider]") || null;
  if(photoTiles){
    photoTilesSlider();
  }
  
  // section : mission.liquid
  let mission = document.querySelector("[data-mission-slider]") || null;
  if(mission){
    missionSlider();
  }
  
  // section : mission.liquid
  let proImgBlock = document.querySelector("[data-pro-image-block-slider]") || null;
  if(proImgBlock){
    proImageBlockSlider();
  }
  
  function newFeaturedCollSlider(){
    var mySwiper = new Swiper("[data-systems-slider]", {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 20,
      slidesPerGroup: 1,
      speed: 900,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        990: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          centeredSlides: false
        },
        750: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          centeredSlides: false
        },
        576: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          centeredSlides: false
        }
      },
    });
  }
  
  function instaSection(){
    var mySwiper = new Swiper("[data-social-slider]", {
      loop: true,
      slidesPerView: 1.4,
      centeredSlides: true,
      spaceBetween: 20,
      slidesPerGroup: 1,
      breakpoints: {
        990: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          centeredSlides: false
        },
        750: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          centeredSlides: false
        },
        576: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          centeredSlides: false
        }
      },
    });
  }
  
  function photoTilesSlider(){
    var mySwiper = new Swiper("[data-photo-tiles-slider]", {
      loop: false,
      slidesPerView: 1.1,
      centeredSlides: true,
      spaceBetween: 10,
      slidesPerGroup: 1,
      breakpoints: {
        990: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          centeredSlides: false,
          spaceBetween: 20
        },
        750: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          centeredSlides: false,
          spaceBetween: 20
        },
        576: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          centeredSlides: false,
          spaceBetween: 10
        }
      }
    });
  
    mySwiper.on('slideChangeTransitionEnd', function () {
      let active = document.querySelector("[data-photo-tiles-nav-item].active");
      if(active) active.classList.remove("active");
      let getNew = document.querySelector(`[data-photo-tiles-nav-item][data-index="${this.activeIndex}"]`);
      getNew.classList.add("active");
    });
  
    let photoSlidesBtn = document.querySelectorAll("[data-photo-tiles-nav-item]");
    photoSlidesBtn.forEach(slide => {
      slide.addEventListener("click",function(){
        let active = document.querySelector("[data-photo-tiles-nav-item].active");
        if(active) active.classList.remove("active");
        slide.classList.add("active");
        mySwiper.slideTo(slide.dataset.index);
      });
    });
  }
  
  function missionSlider(){
    var mySwiper = new Swiper("[data-mission-slider]", {
      autoplay: {
        disableOnInteraction: !1
      },
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: !0
      },
      autoHeight: !0,
      breakpoints: {
        800: {
            autoHeight: !1
        }
      }
    });
  
    let missionBtn = document.querySelectorAll("[data-mission-nav-item]");
    mySwiper.on("slideChange", (function() {
      missionBtn.forEach((function(btn, index) {
          btn.classList.toggle("active", index === mySwiper.activeIndex)
      }));
    }));
    
    missionBtn.forEach((btn, i) => {
      btn.addEventListener("click",function(){
        mySwiper.slideTo(i);
      });
    });
  }
  
  function proImageBlockSlider(){
    var mySwiper = new Swiper("[data-pro-image-block-slider]", {
      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      breakpoints: {
        990: {
          slidesPerView: 2,
          slidesPerGroup: 2
        }
      },
    });
  }
  
  function productTabWithModal() {
    $(document).on("click","[data-pro-tab-item]:not(.active)",function(e){
      e.preventDefault();
      $(this).addClass("active").siblings().removeClass("active");
      let el = $(this).attr("data-id");
      // if($(this).hasClass("pro-tab-item-all")){
      //   $(".pro-tab-content-list .pro-tab-content").addClass("active");
      //   // $(`.pro-tab-content-list #${el}`).addClass("active");
      // }else{
        $(".pro-tab-content-list .pro-tab-content").removeClass("active");
        $(`.pro-tab-content-list #${el}`).addClass("active");
      // }
    });

    $(document).on("click", ".pro-tab-content-row .pro-tab-content-col", function(e) {
      e.preventDefault();
      var premiumPack = $("[data-premium-pack]");
      var packDetailsModal = $('[data-modal="pack-item-details"]');
      
      if (premiumPack.length > 0 && packDetailsModal.length > 0) {
        var packItems = premiumPack.find("[data-item]");
        var detailsImages = packDetailsModal.find("[data-details-image]");
        var detailsTitle = packDetailsModal.find("[data-details-title]");
        var detailsQuantity = packDetailsModal.find("[data-details-qty]");
        var detailsDescription = packDetailsModal.find("[data-details-desc]");
        var itemData = $(this).data();
  
        var title = itemData.title;
        var quantity = itemData.qty;
        var image = itemData.image;
        var description = itemData.desc;
        
        if (detailsTitle.length > 0) {
            detailsTitle.html(title);
        }
        if (detailsDescription.length > 0) {
            detailsDescription.html(description);
        }
        if (detailsQuantity.length > 0) {
            detailsQuantity.html(quantity);
        }
        detailsImages.each(function() {
            $(this).attr("src", image);
            $(this).attr("alt", title);
        });
        
        for (var featureIndex = 1; featureIndex <= 3; featureIndex++) {
          var featureElement = packDetailsModal.find('[data-details-feature="' + featureIndex + '"]');
          if (featureElement.length === 0) {
              break;
          }
          var featureTitle = featureElement.find("[data-details-feature-title]");
          var featureIcon = featureElement.find("[data-details-feature-icon]");
          if (featureTitle.length === 0 || featureIcon.length === 0) {
              break;
          }
          var featureTitleText = $(this).data("feature" + featureIndex + "_title");
          var featureIconSrc = $(this).data("feature" + featureIndex + "_icon");
          featureTitle.html(featureTitleText);
          console.log(featureTitleText, featureIconSrc);
          if (featureIconSrc != '') {
            featureIcon.attr("src", featureIconSrc);
            featureIcon.attr("alt", featureTitleText);
          } else {
            featureElement.addClass('hidden')
          }
          featureElement.toggleClass("hidden", !featureIconSrc || !featureTitleText);
        }
        $("body").addClass("overflow-hidden");
        $('.product-tab-content-modal').addClass("active");
      }
    });
  
    var modalContent, premiumCompare;
    modalContent = document.querySelector('[data-modal="comparison"] [data-modal-content]');
    premiumCompare = document.querySelector("[data-premium-compare]");
    
    if (modalContent && premiumCompare) {
      premiumCompare.innerHTML = modalContent.innerHTML;
    }
    $(document).on("click",".product-tab-content-modal .product-tab-modal-close, .product-tab-content-modal .product-tab-modal-overlay",function(e){
      e.preventDefault();
      $(this).parents(".product-tab-content-modal").removeClass("active");
      $("body").removeClass("overflow-hidden");
    });
  
    $(document).on("click","[data-pro-content-acco-btn]",function(e){
      e.preventDefault();
      $(this).parents(".pro-tab-content").siblings().removeClass("open");
      $(this).parents(".pro-tab-content").siblings().find(".pro-tab-content-row-wrap").slideUp();
      $(this).parents(".pro-tab-content").toggleClass("open");
      $(this).parents(".pro-tab-content").find(".pro-tab-content-row-wrap").slideToggle();
    });
  }
  
  /* ***This will only render in the theme editor / customiser***** */
  if (Shopify.designMode) {
    document.addEventListener("DOMContentLoaded", function () {
      document.addEventListener("shopify:section:load", function () {
  
        // section : new-featured-collection.liquid
        const newFeaturedColl = event.target.closest("[data-systems-slider]") || null;
        if (newFeaturedColl) {
          newFeaturedCollSlider
        }
  
        // section : Instagram-section.liquid
        const insta = event.target.closest("[data-social-slider]") || null;
        if(insta){
          instaSection();
        }
  
        // section : photo-tiles.liquid
        let photoTiles = event.target.closest("[data-photo-tiles-slider]") || null;
        if(photoTiles){
          photoTilesSlider();
        }
  
        // section : mission.liquid
        let mission = event.target.closest("[data-mission-slider]") || null;
        if(mission){
          missionSlider();
        }
      });
    });
  }
  
  // Logo Animation
  var get_logo = document.querySelector("[data-header-logo]");
  var get_logo_container = get_logo.querySelector("[data-logo-container]");
  var get_logo_json = get_logo.getAttribute("data-lottie");
  var animationLogo = bodymovin.loadAnimation({
    container: get_logo_container,
    renderer: "svg",
    loop: false,
    autoplay: true,
    path: get_logo_json,
  });
  
  animationLogo.addEventListener('DOMLoaded', function(e) {
    $('#logo____placeholder:not(.hidden)').addClass('hidden');
  });
  
  get_logo.addEventListener("mouseenter", function(){
    if(screen.width > 992){
      setTimeout(function(){animationLogo.goToAndPlay(17, !0)},500);
    }
  });
  setTimeout(function(){
    setInterval(function () {
      animationLogo.goToAndPlay(17, !0);
    }, 10000);
  },10000);
  // Logo Animation
  
  // compitable popup js
  $(document).on("click",".compatible-acc-button button",function(e){
    e.preventDefault();
    $("body").addClass("overflow-hidden");
    $("[data-compitable-acc-modal]").addClass("opened");
  });
  $(document).on("click","[data-compitable-acc-close],[data-compitable-acc-overlay]",function(e){
    e.preventDefault();
    $("body").removeClass("overflow-hidden");
    $("[data-compitable-acc-modal]").removeClass("opened");
  });

});